import { render } from "./ReviewStatus.vue?vue&type=template&id=35dee1c7&scoped=true"
import script from "./ReviewStatus.vue?vue&type=script&lang=js"
export * from "./ReviewStatus.vue?vue&type=script&lang=js"

import "./ReviewStatus.vue?vue&type=style&index=0&id=35dee1c7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35dee1c7"]])

export default __exports__